import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export interface QuizMeta {
  id: string;
  name: string;
  description: string;
  questionCount: number;
  isLocked: boolean;
  isShareToUnlock: boolean;
}

export interface QuizQuestion {
  questionId: string;
  questionPlayerOne: string;
  questionPlayerTwo: string;
  bucketList: string;
  tag: string;
}

export type AnswerType = 'Yes' | 'No' | 'Maybe';

interface HomeSectionsData {
  quizList?: { categories: QuizMeta[] };
}

const COLLECTION = 'couple-en';

export async function fetchQuizCategories(): Promise<QuizMeta[]> {
  const snap = await getDoc(doc(db, COLLECTION, 'homeSections'));
  if (!snap.exists()) return [];
  const data = snap.data() as HomeSectionsData;
  return data.quizList?.categories ?? [];
}

export async function fetchQuizQuestions(quizId: string): Promise<QuizQuestion[]> {
  const snap = await getDoc(doc(db, COLLECTION, quizId));
  if (!snap.exists()) return [];
  const data = snap.data() as { questions?: QuizQuestion[] };
  return data.questions ?? [];
}
